import {
  Component,
  Input,
  OnInit,
  OnChanges
} from '@angular/core';
import { FormGroup } from '@angular/forms';

import { environment } from '@environments/environment';

import { SeguradoService } from '@app/shared/services/segurado.service';
import { MensagemService } from './../../../../../shared/services/mensagem.service';

import { Censo, ConfigCamposFormulario, Loading, Segurado } from '@app/shared/models';
import { MatDialog } from '@angular/material/dialog';
import { OtpSmsComponent } from '../otp-sms/otp-sms.component';
import { GerenciarRecadastramentoService } from '@app/shared/services/gerenciar-recadastramento.service';
import { UtilService } from '@app/shared/services/util.service';
@Component({
  selector: 'app-form-contatos',
  templateUrl: './form-contatos.component.html',
  styleUrls: ['./form-contatos.component.scss'],
})
export class FormContatosComponent implements OnInit, OnChanges {
  @Input() formEtapa4: FormGroup;
  @Input() configCamposFormulario: ConfigCamposFormulario[];
  @Input() censo: Censo;
  @Input() segurado: Segurado;

  carregar = new Loading();
  cliente = environment.cliente;

  statusFlagValidarCelular: boolean;
  jaValidado: boolean = false;

  numeroContato: string;

  constructor(
    private seguradoService: SeguradoService,
    private mensagemService: MensagemService,
    public dialog: MatDialog,
    private gerenciarRecadastramentoService: GerenciarRecadastramentoService,
    private utilService: UtilService
  ) {}

  ngOnInit(): void {
    this.setarValidarCelular(this.censo);
  }

  ngOnChanges(): void {
    this.gerenciarRecadastramentoService
      .getStatusValidacao()
      .subscribe((status) => {
        this.jaValidado = status
    });
  }

  setarValidarCelular(censo: Censo): void {
    if (censo && censo.flagValidarCelular) {
      this.utilService.definirValidatorRequired(this.formEtapa4.get('contatoPrimario'), true);
      this.gerenciarRecadastramentoService.setFlagValidar(censo.flagValidarCelular);
    }
  }

  enviarCodigoCelular(): void {
    if (this.formEtapa4.invalid)
      return this.mensagemService.avisoFormularioInvalido();

    if (this.formEtapa4.get('contatoParaValidar').value == 'CONTATO_UM') {
      this.numeroContato = this.formEtapa4.get('contatoPrimario').value;
    } else {
      this.numeroContato = this.formEtapa4.get('contatoSecundario').value;
    }

    if (this.numeroContato == null || this.numeroContato?.length != 11)
      return this.mensagemService.avisoMensagemAlerta('Não conseguimos validar o número de contato. Verifique se o número foi digitado corretamente ou se o contato escolhido para validação (Contato 1 ou Contato 2) está correto.');

    this.seguradoService.enviarCodigoCelular(this.segurado.id, {celular: this.numeroContato}, this.carregar).subscribe(() => {
      this.abrirModalOTP(this.segurado, this.numeroContato);
      this.mensagemService.avisoMensagemInfo('Verifique o código enviado para o seu celular');
    })
  }

  abrirModalOTP(segurado: Segurado, celular: string) {
    const dialogRef = this.dialog.open(OtpSmsComponent, {
      width: '300px',
      data: {
        segurado: segurado,
        numeroCelular: celular,
      },
    });
  }

  resetarValidacao(): void {
    this.gerenciarRecadastramentoService.setValidacao(false);
  }

  isRequired(campo: string): boolean {
    return this.utilService.isRequiredField(campo, this.formEtapa4)
  }

  isVisible(campo: string): boolean {
    if (!this.configCamposFormulario) return null;

    const isVisible = this.configCamposFormulario.find((_: any) => _.nomeCampo == campo).visivel
    return isVisible;
  }

  get verificarForm(): any {
    return this.utilService.verificarForm(this.formEtapa4);
  }

  get mostrarBotaoProximo(): boolean {
    if (!this.censo.flagValidarCelular || this.jaValidado) {
      return true;
    }

    return false;
  }

  get mostrarBotaoValidar(): boolean {
    if (this.censo.flagValidarCelular && !this.jaValidado) {
      return true;
    }
    return false;
  }
}
